export default __webpack_public_path__ + "static/media/avatar_39.3a5bd1fb.png";